// material-ui
import { styled } from '@mui/material/styles';
import AppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';

// project import
import { drawerWidth } from 'config';
import { DRAWER_TRANSITION_DURATION, DRAWER_TRANSITION_EASING } from '../Drawer/MiniDrawerStyled';

// ==============================|| HEADER - APP BAR STYLED ||============================== //

interface Props extends MuiAppBarProps {
  open?: boolean;
}

const AppBarStyled = styled(AppBar, { shouldForwardProp: (prop) => prop !== 'open' })<Props>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  mx: 4,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: DRAWER_TRANSITION_EASING,
    duration: DRAWER_TRANSITION_DURATION
  }),
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 32,
    right: 32,
    height: '1px',
    backgroundColor: theme.palette.divider
  },
  ...(!open && {
    width: `calc(100% - ${theme.spacing(7.5)})`
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: DRAWER_TRANSITION_EASING,
      duration: DRAWER_TRANSITION_DURATION
    })
  })
}));

export default AppBarStyled;
